<template>
  <div>
    <div v-if="!loading && companies.length > 1" class="pt-2">
      <div class="clear">
        <v-container grid-list-md class="pa-0" fluid>
          <v-layout row wrap>
            <v-flex md3 xs12>
              <v-select
                v-if="!loading && companies.length > 1"
                :items="filteredCompanies"
                :item-color="companyPrimaryColor"
                :background-color="$vuetify.theme.themes[theme].menu"
                item-text="name"
                item-value="id"
                v-on:input="loadActiveCompData()"
                v-model="activeComp"
                no-data-text="Geen aansluiting gevonden."
                label="Selecteer aansluiting"
                outlined
                dense><template v-slot:prepend-item>
                  <v-list-item>
                    <v-list-item-content class="pt-0" >
                      <v-text-field
                        :color="companyPrimaryColor"
                        placeholder="Zoeken"
                        prepend-inner-icon="search"
                        clearable
                        background-color="background"
                        outlined
                        v-model="searchCompanies"
                        hide-details
                        dense
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} aansluitingen</div>
                  <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </div>

    <div v-if="loading" class="blackbox-loader"></div>
  
    <div v-if="loading == false" class="special-content-box">
      <v-tabs background-color="background" show-arrows>
        <v-tab @click="tab='1'" >Extensions</v-tab>
        <v-tab v-if="userRole == 'superadmin'" @click="tab='2'" >Locaties</v-tab> 
        <v-tab @click="tab='3', testMedicomAPI()" >API-koppelingen</v-tab>
        <v-tab @click="tab='4'" >Gebruikers</v-tab>
        <v-tab v-if="userRole == 'superadmin'" @click="tab='5'" >3CX-instellingen</v-tab>
        
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="1" :transition="tabTransition" :reverse-transition="tabTransition">
          <v-card outlined class="pa-0">

            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap class="pa-4">
                <v-flex md8 xs12>
                  <h1 class="tab-title">Extensions</h1>
                </v-flex>

                <v-flex md4 xs12>
                  <v-row v-if="extentions.length > 0">
                    <v-text-field
                      class="px-2"
                      v-model="searchExtentions"
                      :color="companyPrimaryColor"
                      name="searchfield"
                      placeholder="Zoeken"
                      outlined
                      background-color="background"
                      hide-details                                                     
                      prepend-inner-icon="search"
                      autocomplete="disabled"
                      clearable
                      single-line>
                    </v-text-field>
                    <v-btn class="px-2" fab dark :color="companyPrimaryColor" @click="newExtentionDialog = true">
                      <v-icon darken>add</v-icon>
                    </v-btn>
                    <v-btn class="px-2 mx-3" fab dark :color="companySecondaryColor" v-if="selectedExtentions.length > 0" @click="deleteExtentions()">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </v-row>
                </v-flex>

              </v-layout>
            </v-container>
  
            <div class="first-item-button text-center pa-4" v-if="extentions.length == 0">
              <p>Er zijn nog geen extensions aangemaakt.</p>
              <v-btn  :color="companySecondaryColor" dark @click="newExtentionDialog = true">
                Voeg een extension toe
              </v-btn>
            </div>
 
            <v-data-table
              v-if="extentions.length > 0"
              :headers="headersExtentions"
              :items="extentions"
              :search="search"
              :single-select="false"
              show-select
              v-model="selectedExtentions"
              :itemsPerPage.sync="branchesPages"
              hide-default-footer
              :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
              <template v-slot:item="{ item,  isSelected, select }">
                <tr>
                  <td >
                    <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                    <v-icon @click="select(false)" v-if="isSelected" >check_box</v-icon>
                  </td>
                  <td>{{ item.number }}</td>
                  <td>{{ item.name }}</td>
                  <td>
                    <v-chip small v-if="item.type == 'ivr'" color="#666"><v-icon color="#fff" small left>mdi-source-fork</v-icon> <span style="color: #fff; font-weight: bold">{{ extentionTypeName(item.type) }} </span></v-chip>
                    <v-chip small v-if="item.type == 'urgency'" color="#cf1e1e"><v-icon color="#fff" small left>mdi-phone-ring</v-icon> <span style="color: #fff; font-weight: bold">{{ extentionTypeName(item.type) }} </span></v-chip>
                    <v-chip small v-if="item.type == 'info'" color="#e8cc0d"><v-icon color="#fff" small left>mdi-information</v-icon> <span style="color: #fff; font-weight: bold">{{ extentionTypeName(item.type) }} </span></v-chip>
                    <v-chip small v-if="item.type == 'vmail'" color="#515f6d"><v-icon color="#fff" small left>mdi-voicemail</v-icon> <span style="color: #fff; font-weight: bold">{{ extentionTypeName(item.type) }} </span></v-chip>
                    <v-chip small v-if="item.type == 'landLine'" color="#2580c3"><v-icon color="#fff" small left>mdi-phone</v-icon> <span style="color: #fff; font-weight: bold">{{ extentionTypeName(item.type) }} </span></v-chip>
                    <v-chip small v-if="item.type == 'mobilePhone'"  color="#42d5db"><v-icon color="#fff" small left>mdi-cellphone-iphone</v-icon><span style="color: #fff; font-weight: bold"> {{ extentionTypeName(item.type) }}</span></v-chip> 
                    <v-chip small v-if="item.type == 'group'"  color="#766f5e"><v-icon color="#fff" small left>mdi-account-group</v-icon> <span style="color: #fff; font-weight: bold">{{ extentionTypeName(item.type) }}</span> </v-chip>
                    <v-chip small v-if="item.type == 'queue'" color="#c0bfc4"><v-icon small color="#fff" left>mdi-format-list-numbered</v-icon> <span style="color: #fff; font-weight: bold">{{ extentionTypeName(item.type) }} </span></v-chip>
                  </td>
                  <td>{{ extentionBranchName(item.branch) }}</td>
                  <td>
                    <v-btn style="float: right;" icon class="mx-0" @click="editExtention(item)">
                      <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>    

          </v-card>
        </v-tab-item>

        <v-tab-item value="2" :transition="tabTransition" :reverse-transition="tabTransition">
          <v-card outlined class="pa-0">

            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap class="pa-4">
                <v-flex md8 xs12>
                  <h1 class="tab-title">Locaties</h1>
                </v-flex>

                <v-flex md4 xs12>
                  <v-row v-if="branches.length > 0">
                    <v-text-field
                      class="px-2"
                      v-model="search"
                      :color="companyPrimaryColor"
                      name="searchfield"
                      placeholder="Zoeken"
                      outlined
                      background-color="background"
                      hide-details                                                     
                      prepend-inner-icon="search"
                      autocomplete="disabled"
                      clearable
                      single-line>
                    </v-text-field>
                    <v-btn class="px-2" fab dark :color="companyPrimaryColor" @click="newBranchDialog = true">
                      <v-icon darken>add</v-icon>
                    </v-btn>
                    <v-btn class="px-2  mx-3" fab dark :color="companySecondaryColor" v-if="selected.length > 0" @click="deleteBranch()">
                      <v-icon darken>delete</v-icon>
                    </v-btn>
                  </v-row>
                </v-flex>

              </v-layout>
            </v-container>
  
            <div class="first-item-button text-center pa-4" v-if="branches.length == 0">
              <p>Er zijn nog geen vestingen aangemaakt.</p>
              <v-btn  :color="companySecondaryColor" dark @click="newBranchDialog = true">
                Voeg een locatie toe
              </v-btn>
            </div>
 
            <v-data-table
              v-if="branches.length > 0"
              :headers="headersBranches"
              :items="branches"
              :search="search"
              show-select
              :single-select="false"
              v-model="selected"
              :itemsPerPage.sync="branchesPages"
              hide-default-footer
              :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            >
              <template v-slot:item="{ item,  isSelected, select }">
                <tr>
                  <td >
                    <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                    <v-icon @click="select(false)" v-if="isSelected" >check_box</v-icon>
                  </td>
                  <td>{{ item.branchName }}</td>
                  <td>{{ item.address }} {{ item.number }}<span v-if="item.city && item.address">,</span> {{ item.city }}</td>
                  <td>{{ item.province }}</td>
                  <td>
                    <v-btn style="float: right;" icon class="mx-0" @click="editBranch(item)">
                      <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>    

          </v-card>
        </v-tab-item>
        
        <v-tab-item value="3" :transition="tabTransition" :reverse-transition="tabTransition">
          <v-card outlined>
            <v-container grid-list-md class="pa-4" fluid>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <h1 class="tab-title">API-koppelingen</h1>
                </v-flex>
                <v-flex md6 xs12>
                  <div style="display: inline-block; float: right;">
                    <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="apiSettingsChanged" :loading="apiSettingsSaving" :disabled="!apiSettingsChanged" :depressed="!apiSettingsChanged" @click="updateCompanyApi()">Wijzigingen opslaan<v-icon right dark>chevron_right</v-icon></v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container grid-list-md class="pa-4" fluid>
              <v-layout row wrap  v-if="activeCompData.software == 'medicom'">
                <v-flex md8 xs12>
                  <div class="clear">
                    <div class="api-logo medicom"></div>
                    <v-text-field
                      class="api-input-field"
                      outlined
                      hide-details
                      background-color="background"
                     
                      v-model="activeCompData.apiItems.medicom"
                      :append-icon="showMedicomApiKey ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showMedicomApiKey ? 'text' : 'password'"
                      label="Medicom API Key"
                      @click:append="showMedicomApiKey = !showMedicomApiKey"
                    ></v-text-field>
                    <div class="api-check-icon">
                      <v-icon v-if="apiKeyMedicomStatus == 'success'" color="success">check_circle</v-icon>
                    </div>
                  </div>
                  <div class="pt-2" style="padding-right: 34px" v-if="apiKeyMedicomStatus == 'incorrect'" >
                    <v-alert
                      dense
                      border="left"
                      type="warning"
                    >
                      De opgeslagen API-key is niet correct.
                    </v-alert>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout v-else>
                <v-flex xs12>
                  <div class="first-item-button text-center pa-4">
                    <p>Er zijn geen API-koppelingen beschikbaar.</p>
                  </div>
                </v-flex>
              </v-layout>



            </v-container>


          </v-card>
        </v-tab-item>

        <v-tab-item value="4" :transition="tabTransition" :reverse-transition="tabTransition">
          <v-card outlined>
            <div v-if="loading == false" >
            <div  class="tab-inner-wrapper padding">
              <div class="tab-content">
                <v-container grid-list-md class="pa-4" fluid>
                  <v-layout row wrap>
                    <v-flex md8 xs12>
                      <h1 class="tab-title">Gebruikers</h1>
                    </v-flex>

                    <v-flex md4 xs12>
                      <v-row v-if="employeeUsers.length > 0">
                        <v-text-field
                          class="px-2"
                          v-model="searchUsers"
                          :color="companyPrimaryColor"
                          name="searchfield"
                          placeholder="Zoeken"
                          outlined
                          hide-details
                          background-color="background"                                                     
                          prepend-inner-icon="search"
                          autocomplete="disabled"
                          clearable
                          single-line>
                        </v-text-field>
                        <v-btn class="px-2" fab dark :color="companyPrimaryColor" @click="newUserDialog = true">
                          <v-icon darken>add</v-icon>
                        </v-btn>
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
            </div>

          
            <div class="first-item-button text-center pa-4" v-if="employeeUsers.length == 0">
              <p>Er zijn nog geen gebruikers aangemaakt.</p>
              <v-btn  :color="companySecondaryColor" dark @click="newUserDialog = true">
                Voeg een gebruiker toe
              </v-btn>
            </div>

            <div v-if="employeeUsers.length > 0">
              <v-data-table
                :headers="headerUsers"
                :items="employeeUsers"
                :itemsPerPage.sync="userPages"

                hide-default-footer
                :search="searchUsers"
                :no-results-text="`Geen resultaten gevonden voor: ${searchUsers}`"
                >
                <template v-slot:item="{item}">
                  <tr>
                    <td>
                      <v-icon small :color="activeColor(item.active)">stop</v-icon>
                    </td> 
                    <td>{{ item.firstName}} {{ item.lastName }}</td>
                    <td>
                      <span v-for="(role, index) in userRoles" :key="index">
                        <span v-if="item.userRole == role.id">{{role.name}}</span>
                      </span>
                    <td>
                      <ul style="padding: 0">
                        <li style="display: block; padding: 2px; margin: 0" v-for="(branch, index) in item.branches" :key="index">
                            <span v-for="(companyBranch, index) in branches" :key="index">
                              <span v-if="companyBranch.id == branch">&#8226; {{ companyBranch.branchName }}</span>
                            </span>
                        </li>
                      </ul>
                    <td>{{ item.email }}</td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click="editEmployeeUser(item)">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                      </v-btn>
                    </td>
                  
                  </tr>
                </template>
              </v-data-table>
            </div>
        
          </div>
          </v-card>
        </v-tab-item>

        <v-tab-item value="5" :transition="tabTransition" :reverse-transition="tabTransition">
          <v-card outlined :key="dataChanged">
            <v-container grid-list-md class="pa-4" fluid>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <h1 class="tab-title">3CX-instellingen</h1>
                </v-flex>
                <v-flex md6 xs12>
                  <div style="display: inline-block; float: right;">
                    <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="qmanagerSettingsChanged" :loading="qmanagerSettingsSaving" :disabled="!qmanagerSettingsChanged" :depressed="!qmanagerSettingsChanged" @click="updateCompany3cxSettings()">Wijzigingen opslaan<v-icon right dark>chevron_right</v-icon></v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container grid-list-md class="pa-4" fluid>
              <v-layout row wrap >
                <v-flex md6 xs12>
                  <v-text-field
                    class="mt-2"
                    outlined
                    hide-details
                    background-color="background"
                    v-model="activeCompData['3cxSettings'].url"
                    label="Url"
                    @change="changeData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap >
                <v-flex md6 xs12>
                  <v-text-field
                    class="mt-2"
                    outlined
                    hide-details
                    background-color="background"
                    v-model="activeCompData['3cxSettings'].user"  
                    label="Gebruiker"
                    @change="changeData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap >
                <v-flex md6 xs12>
                  <v-text-field
                    class="mt-2"
                    outlined
                    hide-details
                    @change="changeData"
                    background-color="background"
                    v-model="activeCompData['3cxSettings'].pw"
                    label="Wachtwoord"
                    :append-icon="show3CXPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show3CXPassword ? 'text' : 'password'"
                    @click:append="show3CXPassword = !show3CXPassword"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap >
                <v-flex md6 xs12>
                  <v-select
                    class="mt-2"
                    outlined
                    item-text="name"
                    item-value="id"
                    hide-details
                    :items="versions"
                    @change="changeData"
                    background-color="background"
                    v-model="activeCompData['3cxSettings'].version"
                    label="Versie"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-container>

          </v-card>
        </v-tab-item>
        
      </v-tabs-items>



    </div>

    <!-- / New Branch Dialog \ -->
    <v-dialog v-model="newBranchDialog" scrollable max-width="600px">
      <add-branch-form :activeCompData="activeCompData"  @newBranchDialogChange="newBranchDialog = $event" @updateData="loadBranches('update')"></add-branch-form>
    </v-dialog>
    <!-- \ New Branch Dialog / -->

    <!-- / Edit Branch Dialog \ -->
    <v-dialog v-model="editBranchDialog" scrollable max-width="600px">
        <edit-branch-form :activeCompData="activeCompData"  :selectedBranch="editBranchInfo" :selectedBranchOriginal="editBranchInfoOriginal" @editBranchDialogChange="editBranchDialog = $event" @updateData="loadBranches('update')"></edit-branch-form>
    </v-dialog>
    <!-- \ Edit Branch Dialog / -->

    <!-- / New User Dialog \ -->
    <v-dialog v-model="newUserDialog" max-width="600px">
      <add-user-form :formType="'company'" :userRoles="userRoles" :branches="branches" :activeCompData="activeCompData" :showDialog="newUserDialog" :companies="companies" @newUserDialogChange="newUserDialog = $event" @updateData="loadEmployeeUsers()"></add-user-form>
    </v-dialog>
    <!-- \ New User Dialog / -->

    <!-- / Edit User Dialog \ -->
    <v-dialog v-model="editUserDialog" max-width="600px">
      <edit-user-form :formType="'company'" :branches="branches" :userRoles="userRoles" :activeCompData="activeCompData"  :showEditDialog="editUserDialog" :companies="companies" :userFormInfoOriginal="editUserInfoOriginal" :userFormInfo="editUserInfo" @userEditDialogChange="editUserDialog = $event" @updateData="loadEmployeeUsers()"></edit-user-form>
    </v-dialog>
    <!-- \ Edit User Dialog / -->

     <!-- / New Extention Dialog \ -->
    <v-dialog v-model="newExtentionDialog" scrollable max-width="600px">
      <add-extention-form :activeCompData="activeCompData" :branches="branches" :types="extentionTypes" @newExtentionDialogChange="newExtentionDialog = $event" @updateData="loadExtentions()"></add-extention-form>
    </v-dialog>
    <!-- \ New Extention Dialog / -->

    <!-- / Edit Extention Dialog \ -->
    <v-dialog v-model="editExtentionDialog" scrollable max-width="600px">
        <edit-extention-form :activeCompData="activeCompData" :branches="branches" :types="extentionTypes" :selectedExtention="editExtentionInfo" :selectedExtentionOriginal="editExtentionInfoOriginal" @editExtentionDialogChange="editExtentionDialog = $event" @updateData="loadExtentions()"></edit-extention-form>
    </v-dialog>
    <!-- \ Edit Extention Dialog / -->

  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import axios from "axios";
import _ from "lodash"
import AddBranchForm from "../components/modals/AddBranchForm.vue";
import AddExtentionForm from "../components/modals/AddExtentionForm.vue";
import EditBranchForm from "../components/modals/EditBranchForm.vue";
import AddUserForm from "../components/modals/AddUserForm.vue";
import EditUserForm from "../components/modals/EditUserForm.vue";
import EditExtentionForm from "../components/modals/EditExtentionForm.vue";
import platform from 'platform'; 

export default {
  components: {
    "add-branch-form": AddBranchForm,
    "add-user-form": AddUserForm,
    "add-extention-form": AddExtentionForm,
    "edit-branch-form": EditBranchForm,
    "edit-user-form": EditUserForm,
    "edit-extention-form": EditExtentionForm
  },
  name: "Settings",

  data: () => ({
    activeCompData: {
      '3cxSettings': {
        url: "" 
      },
      apiItems: {}
    },
    versions: [
      {
        name: "<20",
        id: 19
      },
      {
        name: "20+",
        id: 20
      }
    ],
    expandedEmployees: [],
    loading: true,
    feedback: null,  
    paginationBranches: {
      sortBy: "branchName",
      rowsPerPage: 100,
      descending: false
    },
    tab: '1',
    dataChanged: 1,
    tabTransition: false,
    paginationUsers: {
      sortBy: "firstName",
      rowsPerPage: 100,
      descending: false
    },
    search: "",
    searchCompanies: "",
    searchUsers: "",
    editUserInfo: {
      userPermissions: {}
    },
    branchesPages: -1,
    userPages: -1,
    editUserInfoOriginal: {},
    employeeUsers: [],
    activeCompDataOriginal: {},
    showPassword: false,
    editUserDialog: false,
    newUserDialog: false,
    editUserDialog: false,
    removeBookings: "",
    editBranchDialog: false,
    newBranchDialog: false,
    selected: [],
    companies: [],
    branches: [],
    activeComp: "",
    userCompaniesAccess: "",
    showMedicomApiKey: false,
    show3CXPassword: false,
    apiSettingsSaving: false,
    qmanagerSettingsSaving: false,
    apiKeyMedicomStatus: null,

    editBranchInfo: { },
    editBranchInfoOriginal: {},
    searchExtentions:"",
    extentions: [],
    selectedExtentions: [],
    newExtentionDialog: false,
    editExtentionDialog: false,
    editExtentionInfo: { },
    editExtentionInfoOriginal: {},

    extentionTypes: [
      {
        name: "Vaste telefoon",
        id: "landLine"
      },
      {
        name: "IVR",
        id: "ivr"
      },
      {
        name: "Wachtrij",
        id: "queue"
      },
       {
        name: "Spoed",
        id: "urgency"
      },
      {
        name: "Groep",
        id: "group"
      },
      {
        name: "Voicemail",
        id: "vmail"
      },     
      {
        name: "Informatie (opname afspelen)",
        id: "info"
      },
      {
        name: "Mobile telefoon",
        id: "mobilePhone"
      },
    ],

    headersBranches: [
      {
        text: "Naam",
        align: "left",
        value: "branchName"
      },
      {
        text: "Adres",
        align: "left",
        value: "address"
      },
      {
        text: "Provincie",
        align: "left",
        value: "province"
      },
      {
        text: "",
        align: "right",
        value: "edit"
      }
    ],
    headersExtentions: [
      {
        text: "Nummer",
        align: "left",
        value: "number"
      },
      {
        text: "Naam",
        align: "left",
        value: "naam"
      },
      {
        text: "Type",
        align: "left",
        value: "type"
      },
      {
        text: "Locatie",
        align: "left",
        value: "branch"
      },
      {
        text: "",
        align: "right",
        value: "edit"
      }
    ],
    headerUsers: [
      {
        text: "",
        align: "left",
        value: "active",
        width: "30px"
      },
      {
        text: "Naam",
        align: "left",
        value: "firstName" + "Lastname"
      },
      {
        text: "Rol",
        align: "left",
        value: "userRole"
      },
      {
        text: "Locaties",
        align: "left",
        value: "branches"
      },
      {
        text: "Email",
        align: "left",
        value: "email"
      },
      {
        text: "",
        align: "right",
        value: "edit",
        width: "70px"
      },
    ],
  }),

  created() {
    this.loadUserComp();
  },

  methods: {
    loadUserComp() {
      this.loaded = false;
      // let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .where("deleted.deleted", "==", false)
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company.id).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
            this.activeCompData['3cxSettings'] = this.activeCompData['3cxSettings'] ? this.activeCompData['3cxSettings'] : {url: "", pw: "", user: "", version: 19};
          }
          else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0]
        })
        .then(() => {
          this.loading = false;
          this.loadBranches();
          this.loadExtentions();
          this.loadEmployeeUsers();
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

    activeColor(type){
      if(type){
        return 'green'
      }
      else{
        return 'warning';
      }
    },
    
    editBranch(item) {
      this.editBranchDialog = true;
      this.editedIndex = this.branches.indexOf(item);
      this.editBranchInfo = Object.assign({}, item);
      this.editBranchInfoOriginal = _.cloneDeep(this.editBranchInfo) 
    },

    editExtention(item) {
      this.editExtentionDialog = true;
      this.editedIndex = this.extentions.indexOf(item);
      this.editExtentionInfo = Object.assign({}, item);
      this.editExtentionInfoOriginal = _.cloneDeep(this.editExtentionInfo) 
    },
    changeData(){
      this.dataChanged++
    },

    deleteBranch() {
      // Prepearing variables for log. This cannot be done inside a forEach
      var logUserFirst = this.userFirstName;
      var logUserLast = this.userLastName;
      var logUserRole = this.userRole;
      var logUserComp = this.activeComp;

      this.selected.forEach(element => {
        db.collection("branches")
          .doc(element.id)
          .delete()
          .then(() => {
            console.log("Branch successfully deleted!");
          })
          .then(() => {
            this.selected = [];
            this.loadBranches();
          })

          .catch(error => {
            console.error("Error removing branch: ", error);
          });
      });
    },

    deleteExtentions() {
      // Prepearing variables for log. This cannot be done inside a forEach

      this.selectedExtentions.forEach(element => {
        db.collection("extentions")
          .doc(element.id)
          .delete()
          .then(() => {
            console.log("Extention successfully deleted!");
          })
          .then(() => {
            this.selectedExtentions = [];
            this.loadExtentions();
          })
          .catch(error => {
            console.error("Error removing Extention: ", error);
          });
      });
    },

    loadBranches(update) {
      this.loading = true;
      db.collection("branches")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          this.branches = [];
          snap.forEach(doc => {
            let branchCollection = doc.data();
            branchCollection.id = doc.id;
            
            if(this.userRole == 'superadmin'){
              this.branches.push(branchCollection);
            }
            else{
              let branchIndex = this.userBranches.findIndex(branch => branch.id === branchCollection.id);
              if(branchIndex >= 0){
                this.branches.push(branchCollection);
              }
            }  
          });
        })
        .then(()=>{
          if(update){
            this.loading = false;
          }
        })
    },

    loadExtentions() {
      this.loading = true;
      db.collection("extentions")
        .where("compId", "==", this.activeComp)
        .get()
        .then(snap => {
          this.extentions = [];
          snap.forEach(doc => {
            let extention = doc.data();
            extention.id = doc.id;
            if(this.userRole == 'superadmin'){
              this.extentions.push(extention);
            }
            else{
              let branchIndex = this.userBranches.findIndex(branch => branch.id === extention.branch);
              if(extention.branch && branchIndex >= 0){
                this.extentions.push(extention);
              }
            }        
          });
        })
        .then(() => {
          this.extentions = _.orderBy(this.extentions, ['number'], ['asc']);
          this.loading = false;
        });
    },

    updateCompanyApi(){
      this.apiSettingsSaving = true;
      db.collection("companies")
        .doc(this.activeComp)
        .set({
          apiItems: this.activeCompData.apiItems,
        },{merge: true})
      .then(()=>{
        this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        this.apiSettingsSaving = false;
        this.testMedicomAPI();
      })
    },

    updateCompany3cxSettings(){
      this.qmanagerSettingsSaving = true;
      db.collection("companies")
        .doc(this.activeComp)
        .set({
          '3cxSettings': this.activeCompData['3cxSettings'],
        },{merge: true})
      .then(()=>{
        this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
        this.qmanagerSettingsSaving = false;
      })
    },

    testMedicomAPI(){
      if(this.activeCompData.apiItems.medicom){
        let data = JSON.stringify({
          apiKey: this.activeCompData.apiItems.medicom,
          extension: '200',
          test: true,
          incomingNumber: '+316123456789',
        })
        var config = {
          method: 'post',
          url: 'https://medicom.hogans.nl/popup',
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };
        axios(config)
        .then(response=> {
          if(response.data == 'ok'){
            // Post succesfull
            this.apiKeyMedicomStatus = 'success';
          }
        })
        .catch(error=> {
          if( error.response.data == 'No valid api key provided'){
            this.apiKeyMedicomStatus = 'incorrect';
          }
          console.error(error.response.data);
        });
      }
      else{
        this.apiKeyMedicomStatus = null;
      }     
    },

    extentionTypeName(id){
      let typeName = id;
      this.extentionTypes.forEach(type=>{
        if(type.id == id){
          typeName = type.name;
        }
      })
      return typeName;
    },

    extentionBranchName(id){
      let branchName = id;
      this.branches.forEach(branch=>{
        if(branch.id == id){
          branchName = branch.branchName;
        }
      })
      return branchName;
    },

    loadEmployeeUsers() {
      this.loading = true;
      db.collection("users")
        .where("company", "==", this.activeComp)
        .get()
        .then(snap => {
          this.employeeUsers = [];
          snap.forEach(doc => {
            let userCollection = doc.data();
            userCollection.id = doc.id;
            this.employeeUsers.push(userCollection);
          });
        })
        .then(() => {
          this.loading = false;
        });
    },

    editEmployeeUser(item) {
      this.editUserDialog = true;
      this.editedIndex = this.employeeUsers.indexOf(item);
      this.editUserInfo = _.cloneDeep(item);
      this.editUserInfoOriginal = _.cloneDeep(item);
      bus.$emit("getCompanyBranches", this.editUserInfo.company);
    },
  },

  computed: {  
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    userRoles(){
      let roles = [
        {
          name: "Super Admin",
          id: "superadmin",
        },
        {
          name: "Admin",
          id: "admin"
        },
        {
          name: "Manager",
          id: "manager"
        },
        {
          name: "Medewerker",
          id: "employee"
        }
      ];

      let permittedRoles = []

      roles.forEach(role=>{
        if(this.userRole == 'superadmin' && role.id =='superadmin'){
          permittedRoles.push(role)
        }
        if((this.userRole == 'superadmin' || this.userRole == 'admin') && role.id =='admin'){
          permittedRoles.push(role)
        }
        if((this.userRole == 'superadmin' || this.userRole == 'admin' || this.userRole == 'manager') && role.id =='manager'){
          permittedRoles.push(role)
        }
        if(role.id =='employee'){
          permittedRoles.push(role)
        }
      })

      return permittedRoles;
    },

    
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    userBranches() {
      return this.$store.state.userBranches;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyNarrowcasting() {
      if (_.includes(this.$store.state.companyPackages, "narrowcasting")) {
        return true;
      } else {
        return false;
      }
    },
    companyJourney() {
      if (_.includes(this.$store.state.companyPackages, "customerjourney")) {
        return true;
      } else {
        return false;
      }
    },
    apiSettingsChanged(){
      if ( _.isEqual(this.activeCompData.apiItems, this.activeCompDataOriginal.apiItems) == false) {
        return true
      } else {
        return false
      }
    },
     qmanagerSettingsChanged(){  
      let sven = this.dataChanged;
      if(_.isEqual(this.activeCompData['3cxSettings'], this.activeCompDataOriginal['3cxSettings']) == false) {
        return true
      } else {
        return false
      }
    },
    socialChanged() {
      if (_.isEqual(this.activeCompData.social, this.activeCompDataOriginal.social) == false) {
        return true;
      } else {
        return false;
      }
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    }
    
  }
};
</script>
<style>
.api-logo{
  display: block;
  width: 150px;
  height: 55px;
  float: left;
  background: url("../assets/logo-medicom.png") no-repeat center center;
  background-size: 150px auto;
  margin: 0px 15px 0 0 ;
}

.api-input-field{
  display: block;
  float: left;
  width: calc(100% - 200px);
}

.api-check-icon{
  display: block;
  float: left;
  width: 34px;
  padding: 16px 5px;
}
</style>